(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  ready(function () {
    var modal = document.getElementById('RentalDocumentModal');
    var modalTitle = document.getElementById('RentalDocumentModalTitle');
    var modalBody = document.getElementById('RentalDocumentModalBody');

    if (!modal || !modalTitle || !modalBody) return;

    var lastFocusedElement = null;

    /*
      Move the modal directly under <body>, following the same approach used
      by the supplied Prismatic privacy-policy modal. This prevents the modal
      from being clipped by sticky, transformed, or overflow-hidden parents.
    */
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    function getDocumentDetails(type) {
      if (type === 'why') {
        return {
          title: 'Why We Need These Documents',
          templateId: 'RentalDocumentWhyContent'
        };
      }

      if (type === 'nric') {
        return {
          title: 'NRIC Front & Back',
          templateId: 'RentalDocumentNricContent'
        };
      }

      if (type === 'address') {
        return {
          title: 'Proof of Address',
          templateId: 'RentalDocumentAddressContent'
        };
      }

      return null;
    }

    function openDocumentModal(trigger) {
      var type = trigger.getAttribute('data-rental-document-modal');
      var details = getDocumentDetails(type);

      if (!details) return;

      var template = document.getElementById(details.templateId);
      if (!template) return;

      lastFocusedElement = trigger;
      modalTitle.textContent = details.title;
      modalBody.innerHTML = template.innerHTML;

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('rental-modal-open');
      document.body.classList.add('rental-modal-open');

      var closeButton = modal.querySelector('[data-rental-document-modal-close]');
      if (closeButton) closeButton.focus();
    }

    function closeDocumentModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('rental-modal-open');
      document.body.classList.remove('rental-modal-open');

      if (lastFocusedElement) {
        lastFocusedElement.focus();
      }
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-rental-document-modal]');

      if (trigger) {
        event.preventDefault();
        openDocumentModal(trigger);
        return;
      }

      if (
        event.target === modal ||
        event.target.closest('[data-rental-document-modal-close]')
      ) {
        closeDocumentModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        closeDocumentModal();
      }
    });
  });
})();
